import { RefreshCcw } from "lucide-react";
import React from "react";
import { ToastContainer } from "react-toastify";

const PrintingSettings = ({
  printSettings,
  printConfig,
  printForm,
  handlePrintChange,
  handleSavePrintSettings,

  printType,
  setPrintType,
  handleSavePrintType,

  printers,
  setShowPrinterModal,
  getPrinters,
  showPrinterModal,
  printerForm,
  handlePrinterChange,
  handleSavePrinter,
  handleRefreshPrintSettings,
  
}) => {
  return (
    <>

    <div className="grid lg:grid-cols-2 gap-6 montserrat-font-1">
      {/* LEFT SIDE */}
      <div className="space-y-6 montserrat-font-1">
        {/* CURRENT SETTINGS */}
        <div className="bg-white border rounded-xl p-6 shadow-sm montserrat-font-1">
          <div className="flex justify-between items-center mb-4">
            <h2 className="text-green-700 font-semibold">Print Settings</h2>

            <button
              onClick={() => setShowPrinterModal(true)}
              className="bg-blue-500 text-white text-sm px-3 py-1 rounded"
            >
              Add Printer
            </button>
          </div>

          <div className="border-t pt-4 space-y-2 text-sm">
            <div className="flex justify-between">
              <span>Use Anlook Printing Software:</span>
              <span>
                {printConfig.autoPrint === "1" ? "Enabled" : "Disabled"}
              </span>
            </div>

            <div className="flex justify-between">
              <span>Auto-Print Receipts:</span>
              <span>
                {printConfig.autoPrint === "1" ? "Enabled" : "Disabled"}
              </span>
            </div>
          </div>

          <hr className="my-4" />

          {printSettings.map((p, i) => (
            <div key={i} className="flex justify-between text-sm">
              <span>{p.key}</span>
              <span>{p.value}</span>
            </div>
          ))}
        </div>

        {/* UPDATE SETTINGS */}
        <div className="bg-white p-6 rounded-2xl space-y-2">
          <div className="flex justify-between items-center mb-3">
            <h2 className="text-green-700 font-semibold">
              Update Printing Setting
            </h2>

            <button
              onClick={handleRefreshPrintSettings}
              className="border px-3 py-1 flex items-center gap-2 bg-green-600 rounded-lg text-white"
            >
              <RefreshCcw size={14} /> Refresh
            </button>
          </div>

          <label className="text-sm text-gray-700">Normal Font Size</label>

          <input
            value={printForm.normalFontSize || ""}
            onChange={(e) =>
              handlePrintChange("normalFontSize", e.target.value)
            }
            className="w-full border px-3 py-1 rounded"
          />

          <label className="text-sm text-gray-700">Large Font Size</label>

          <input
            value={printForm.largeFontSize || ""}
            onChange={(e) => handlePrintChange("largeFontSize", e.target.value)}
            className="w-full border px-3 py-2 rounded"
          />

          <label className="text-sm text-gray-700">Page Width</label>

          <input
            value={printForm.pageWidth || ""}
            onChange={(e) => handlePrintChange("pageWidth", e.target.value)}
            className="w-full border px-3 py-2 rounded mb-3"
          />

          {/* Toggle */}
          <div className="flex items-center gap-3 mt-3">
            <label className="relative inline-flex items-center cursor-pointer">
              <input
                type="checkbox"
                className="sr-only peer"
                checked={printForm.anlookActive === "1"}
                onChange={(e) =>
                  handlePrintChange(
                    "anlookActive",
                    e.target.checked ? "1" : "0",
                  )
                }
              />
              <div
                className="w-11 h-6 bg-gray-300 rounded-full peer 
                peer-checked:bg-green-600 
                after:content-[''] after:absolute after:top-[2px] after:left-[2px] 
                after:bg-white after:rounded-full after:h-5 after:w-5 
                after:transition-all peer-checked:after:translate-x-full"
              ></div>
            </label>
            <span className="text-sm text-gray-700">anlookActive</span>
          </div>

          <div className="flex items-center gap-3">
            <label className="relative inline-flex items-center cursor-pointer">
              <input
                type="checkbox"
                className="sr-only peer"
                checked={printForm.autoPrint === "1"}
                onChange={(e) =>
                  handlePrintChange("autoPrint", e.target.checked ? "1" : "0")
                }
              />
              <div
                className="w-11 h-6 bg-gray-300 rounded-full peer 
          peer-checked:bg-green-600 
          after:content-[''] after:absolute after:top-[2px] after:left-[2px] 
          after:bg-white after:rounded-full after:h-5 after:w-5 
          after:transition-all peer-checked:after:translate-x-full"
              ></div>
            </label>
            <span className="text-sm">autoPrint</span>
          </div>

          <div>
            <label className="text-sm text-gray-700">
              printKotCount (Count)
            </label>
            <input
              type="number"
              value={printForm.printKotCount}
              onChange={(e) =>
                handlePrintChange("printKotCount", e.target.value)
              }
              className="w-full mt-1 px-3 py-2 border rounded-lg"
            />
          </div>

          <div>
            <label className="text-sm text-gray-700">
              printReceiptCount (Count)
            </label>
            <input
              type="number"
              value={printForm.printReceiptCount}
              onChange={(e) =>
                handlePrintChange("printReceiptCount", e.target.value)
              }
              className="w-full mt-1 px-3 py-2 border rounded-lg"
            />
          </div>

          <div className="flex items-center gap-3">
            <label className="relative inline-flex items-center cursor-pointer">
              <input
                type="checkbox"
                className="sr-only peer"
                checked={printForm.printEnabled === "Y"}
                onChange={(e) =>
                  handlePrintChange(
                    "printEnabled",
                    e.target.checked ? "Y" : "N",
                  )
                }
              />
              <div
                className="w-11 h-6 bg-gray-300 rounded-full peer 
          peer-checked:bg-green-600 
          after:content-[''] after:absolute after:top-[2px] after:left-[2px] 
          after:bg-white after:rounded-full after:h-5 after:w-5 
          after:transition-all peer-checked:after:translate-x-full"
              ></div>
            </label>
            <span className="text-sm">printEnabled</span>
          </div>

          <div className="flex items-center gap-3">
            <label className="relative inline-flex items-center cursor-pointer">
              <input
                type="checkbox"
                className="sr-only peer"
                checked={printForm.kotEnabled === "Y"}
                onChange={(e) =>
                  handlePrintChange("kotEnabled", e.target.checked ? "Y" : "N")
                }
              />
              <div
                className="w-11 h-6 bg-gray-300 rounded-full peer 
          peer-checked:bg-green-600 
          after:content-[''] after:absolute after:top-[2px] after:left-[2px] 
          after:bg-white after:rounded-full after:h-5 after:w-5 
          after:transition-all peer-checked:after:translate-x-full"
              ></div>
            </label>
            <span className="text-sm">kotEnabled</span>
          </div>

          <button
            onClick={handleSavePrintSettings}
            className="bg-green-600 text-white px-4 py-2 rounded "
          >
            Save Settings
          </button>
        </div>
      </div>

      {/* RIGHT SIDE */}
      <div className="space-y-6">
        {/* PRINT TYPE */}
        <div className="bg-white p-6 rounded-2xl">
          <h2 className="text-green-700 font-semibold text-xl">
            Anlook Auto Printing Settings
          </h2>
          <div className="flex justify-between items-center">
            <div className="flex gap-4">
              {["1", "2", "3"].map((val) => (
                <label
                  key={val}
                  className="flex items-center gap-2 cursor-pointer"
                >
                  <input
                    type="radio"
                    value={val}
                    checked={printType === val}
                    onChange={(e) => setPrintType(e.target.value)}
                  />
                  <span>
                    {val === "1"
                      ? "Default"
                      : val === "2"
                        ? "Item Wise"
                        : "Category Wise"}
                  </span>
                </label>
              ))}
            </div>

            <button
              onClick={handleSavePrintType}
              className="bg-blue-500 text-white px-4 py-1.5 rounded"
            >
              Save
            </button>
          </div>
        </div>

        {/* PRINTER LIST */}
       <div className="bg-white border rounded-xl shadow-sm overflow-hidden">
  <h2 className="text-center py-3 font-semibold text-green-700 border-b">
    Current Printers
  </h2>

  <table className="w-full text-sm text-left">
    <thead className="bg-green-100 text-gray-800">
      <tr>
        <th className="px-4 py-2 text-left">#</th>
        <th className="px-4 py-2 text-left">Name</th>
        <th className="px-4 py-2 text-left">Code</th>
        <th className="px-4 py-2 text-left">Alias</th>
      </tr>
    </thead>

    <tbody>
      {(printers || []).map((p, i) => (
        <tr
          key={p.id || i}
          className="border-b hover:bg-gray-50 transition"
        >
          <td className="px-4 py-2">{i + 1}</td>
          <td className="px-4 py-2">{p.printerName || "-"}</td>
          <td className="px-4 py-2">{p.printerCode || "-"}</td>
          <td className="px-4 py-2">{p.printerAlias || "-"}</td>
        </tr>
      ))}
    </tbody>
  </table>
</div>
      </div>

      {/* Add printer model */}

      {showPrinterModal && (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
          <div className="bg-white w-full max-w-md rounded-xl p-6 relative shadow-lg">
            <button
              onClick={() => setShowPrinterModal(false)}
              className="absolute top-3 right-3 text-gray-500 hover:text-black text-lg"
            >
              ✕
            </button>

            <h2 className="text-lg font-semibold mb-4">Add New Printer</h2>

            <div className="space-y-4">
              <div>
                <label className="text-sm text-gray-600">Printer Name</label>
                <input
                  name="printerName"
                  value={printerForm.printerName}
                  onChange={handlePrinterChange}
                  className="w-full mt-1 px-3 py-2 border rounded-lg"
                />
              </div>

              <div>
                <label className="text-sm text-gray-600">Printer Alias</label>
                <input
                  name="printerAlias"
                  value={printerForm.printerAlias}
                  onChange={handlePrinterChange}
                  className="w-full mt-1 px-3 py-2 border rounded-lg"
                />
              </div>

              <div>
                <label className="text-sm text-gray-600">Device Name</label>
                <input
                  name="deviceName"
                  value={printerForm.deviceName}
                  onChange={handlePrinterChange}
                  className="w-full mt-1 px-3 py-2 border rounded-lg"
                />
              </div>

              <div>
                <label className="text-sm text-gray-600">Device No.</label>
                <input
                  name="deviceNumber"
                  value={printerForm.deviceNumber}
                  onChange={handlePrinterChange}
                  className="w-full mt-1 px-3 py-2 border rounded-lg"
                />
              </div>

              <button
                onClick={handleSavePrinter}
                className="w-full bg-green-500 hover:bg-green-600 text-white py-2 rounded-lg"
              >
                Save Printer
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
    </>
  );
};

export default PrintingSettings;
